<div class="tier-header" [class.tier-header--breadcrumb]="breadcrumb">
  <ng-container *ngIf="!breadcrumb">
    <span class="tier-header__link" [routerLink]="['/dashboard']">TRENDS</span>
  </ng-container>
  <ng-container *ngIf="breadcrumb">
    <span class="tier-header__link" [routerLink]="['/dashboard']">TRENDS</span>
    <span class="tier-header__separator">></span>
    <span class="tier-header__link" [routerLink]="[breadcrumbLink || '/dashboard']">{{ breadcrumb }}</span>
  </ng-container>
</div>